import "../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/vanilla.virtual.css?%7B%22fileName%22%3A%22src%2Fviews%2Fhome%2Flogged-out-homepage%2F__internal__%2Fcomponents%2FTopHeaderBanner%2Fstyles.css.ts.vanilla.css%22%2C%22source%22%3A%22%23H4sIAAAAAAAAA51S3WqDMBS%2B9ynOzaCFKUm0qY03e5VMo6bUGGxGA8N3H8bf2THdQC88%2Bf78TgJ9VVeVI%2Fj0AEohi9IwyKXx01oZoUziAVS8KaRigKm2idd6Qc%2FB%2F%2BBEjqN5lklVMIhibSEkHWSmIOAfpl6QTkuSfxO5YUCinjROmz5FP56Y1DGHs9HHCGt8fpOFYv3RNLyXPKsfDLC27o20haZ45wf0CsMTkNOxM3irRCY53NNGCAVcZXCouPUfMjMlgzM9a3sE5z5ECd3H3BdBcR%2BnnTHRgJn7QV0SOgJ%2FtpVqto3XtmiQHMsde1u44m3IUzDaVROj34PNfWBEwnUyMmhOEPSSuMFyP6lQRjR%2F%2Bvs93utlhHR3xxh1%2FXyXe6rntF8u6na8IRe7a4DJbtEL2RZ1eoDpdA3bLzO5JWwMBAAA%22%7D"
export var DESKTOP_BANNER_HEIGHT = 591;
export var DESKTOP_BANNER_WIDTH = 420;
export var MOBILE_BANNER_HEIGHT = 264;
export var MOBILE_BANNER_WIDTH = 355;
export var TABLET_BANNER_HEIGHT = 366;
export var TABLET_BANNER_WIDTH = 704;
export var XL_DESKTOP_BANNER_HEIGHT = 628;
export var XL_DESKTOP_BANNER_WIDTH = 698;
export var XXL_DESKTOP_BANNER_WIDTH = 842;
export var condensedContainer = 'pjnjnf1';
export var container = 'pjnjnf0';
export var credit = 'pjnjnf6';
export var halfBanner = 'pjnjnf2';
export var imageContainer = 'pjnjnf3';
export var leftContent = 'pjnjnf4';
export var leftContentCondensed = 'pjnjnf5';